import _ from 'lodash';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';

// Hooks
import { useStores } from 'hooks/use-stores';

// Utils
import { formatCentsToPrice } from 'utils/Currency';
import ModifierGroup from 'models/ModifierGroup';
import CartModifier from 'models/CartModifier';
import { Body, GroupHeading, ItemModifiersGroupTotal, Mod } from './styles';

const GroupTotal = ({ groupPrice, currency }: { groupPrice: number; currency: string }): React.ReactElement | null =>
  !groupPrice ? null : <ItemModifiersGroupTotal>{formatCentsToPrice(groupPrice, currency)}</ItemModifiersGroupTotal>;

const ItemModifiers = ({ item }: { item: CartModifier }) => {
  const [sortedGroups, setSortedGroups] = useState<Array<ModifierGroup>>([]);
  const [visibleGroups, setVisibleGroups] = useState<Array<ModifierGroup>>([]);
  const { menuDataStore } = useStores();

  useEffect(() => {
    setSortedGroups(
      _.orderBy(
        Object.keys(item.mods).map((groupId) => menuDataStore.modifierGroupsById[groupId]),
        ['display_position', 'heading_name']
      )
    );
  }, [item, menuDataStore]);

  useEffect(() => {
    setVisibleGroups(sortedGroups.filter((group) => !group.integrations.hide_from_guests));
  }, [sortedGroups]);

  if (!item.hasMods()) {
    return null;
  }

  return (
    <>
      {visibleGroups.map((group) => {
        const mods = (item.mods[group.id] || []).filter((mod) => mod.selected);
        const groupPrice = _.sumBy(mods, 'menuItem.price_in_cents');

        if (!mods.length) {
          return null;
        }

        return (
          <Body key={`item-mods-${group.id}`} data-testid={`selected-modifier-heading-${group.heading_name}`}>
            <GroupHeading>
              {group.heading_name} <GroupTotal groupPrice={groupPrice} currency={menuDataStore?.currencyCode} />
            </GroupHeading>
            {mods.map((mod) => {
              const isInvalid = !!mod.numMissingSelections;
              return (
                <Mod key={mod.menu_item_id}>
                  <div className={`${isInvalid ? 'invalid' : ''}`}>
                    <span data-testid={mod.name}>
                      {mod.qty > 1 ? `${mod.qty} x ` : ''}
                      {mod.name}
                    </span>
                    {isInvalid && <span>* Selection Required</span>}
                  </div>
                  {mod.hasMods() && <ItemModifiers item={mod} />}
                </Mod>
              );
            })}
          </Body>
        );
      })}
    </>
  );
};

export default observer(ItemModifiers);
